import { render, staticRenderFns } from "./writeInvoice.vue?vue&type=template&id=1f2b0aa4&scoped=true&"
import script from "./writeInvoice.vue?vue&type=script&lang=js&"
export * from "./writeInvoice.vue?vue&type=script&lang=js&"
import style0 from "./writeInvoice.vue?vue&type=style&index=0&id=1f2b0aa4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2b0aa4",
  null
  
)

export default component.exports